import {DefaultRole, Role, UserData} from '@/scripts/types/generated';

export const getFullName = (user?: UserData): string | undefined => {
	if (!user?.firstName && !user?.lastName) {
		return user?.email ?? undefined;
	}

	if (user?.firstName && !user?.lastName) {
		return user.firstName;
	}

	if (!user?.firstName && user?.lastName) {
		return user.lastName;
	}

	return `${user.firstName} ${user.lastName}`;
};

export const getRoleName = (role: DefaultRole | Role | null) => {
	if (!role) {
		return '';
	}

	if (typeof role === 'string') {
		return role;
	}

	return role.name;
};
